/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"];
import "./index.compiled.css";
import { forwardRef } from 'react';
import { ax, ix } from "@compiled/react/runtime";
import React, { memo } from 'react';
import { useIntl } from 'react-intl-next';
import UFOInteractionIgnore from '@atlaskit/react-ufo/interaction-ignore';
import Spinner from '@atlaskit/spinner';
import Tooltip from '@atlaskit/tooltip';
import messages from './messages';
export var FieldBusyIndicator = /*#__PURE__*/memo(function (_ref) {
  var fieldId = _ref.fieldId;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var loadingMessage = formatMessage(messages.fieldLevelIndicatorTooltipContent);
  var indicatorId = "issue-adjustments.ui.field-loading-indicator.".concat(fieldId);
  var tooltipId = "issue-adjustments.ui.field-loading-indicator.tooltip.".concat(fieldId);
  return /*#__PURE__*/React.createElement(Tooltip, {
    tag: "span",
    content: loadingMessage,
    testId: tooltipId
  }, /*#__PURE__*/React.createElement(BusyIconIndentsWrapper, null, /*#__PURE__*/React.createElement(UFOInteractionIgnore, null, /*#__PURE__*/React.createElement(Spinner, {
    testId: indicatorId,
    size: "small"
  }))));
});
FieldBusyIndicator.displayName = 'FieldBusyIndicator';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var BusyIconIndentsWrapper = forwardRef(function (_ref2, __cmplr) {
  var _ref2$as = _ref2.as,
    C = _ref2$as === void 0 ? "span" : _ref2$as,
    __cmpls = _ref2.style,
    __cmplp = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_18u012x7", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  BusyIconIndentsWrapper.displayName = 'BusyIconIndentsWrapper';
}